import { render } from "./PastWinnersList.vue?vue&type=template&id=37edf82c&bindings={}"
import script from "./PastWinnersList.vue?vue&type=script&lang=ts"
export * from "./PastWinnersList.vue?vue&type=script&lang=ts"

import "./PastWinnersList.vue?vue&type=style&index=0&lang=less"
script.render = render

export default script